// extracted by mini-css-extract-plugin
export default {"container":"highLightSectionName_container__x9dNr"};